import {
  TableContainer,
  TableBody,
  TableCell,
  Table,
  TableRow,
  Grid,
} from "@material-ui/core";
import { PencilIcon, TrashIcon } from "App/Assets";
import {
  TableHeader,
  IconButtonDatatable,
  DatatablesFooter,
  ModalDeleteConfirm,
  MasterButton,
} from "App/Component/ui";
import { instance4 } from "App/constants";
import { useDatatables } from "App/hooks";
import {
  convertToValidPrice,
  // defaultDateDisplay,
  defaultDateInputDisplay,
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  isNull,
  today,
} from "App/utils/helpers";
import React, { useState, useContext } from "react";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { FormContext } from "./context/FormContext";
import { requiredMsg } from "App/utils/validation";
import { ModalBarang } from "./ui/DataBarang/helpers";
import { RenderStatusPembelianBadge } from "../DaftarPembelian/helpers";
import { getUserName } from "App/utils/cookies";

export const urlCreatePembelian = "/wmsAsset/pembelian/add_pembelian";
export const urlCreatePembelianByPO = "/wmsAsset/pembelian/add-pembelian-by-po";
export const urlUpdatePembelian = "/wmsAsset/pembelian/update_pembelian";
// export const urlAcceptPembelian = "/wmslogistik/pembelian/listTotalPembelian";
// export const urlAcceptPembelian =
//   "/wmslogistik/inventory/acceptPembelianCekHPP";
export const urlAcceptPembelian = "/wmsAsset/pembelian/update_status_pembelian";

export const urlGetPembelianById = "/wmsAsset/pembelian/list_id";

export const urlGetPembelianItemByPembelianId =
  "wmsAsset/pembelian/list-item-id";

export const urlCreateBarang = "/wmsAsset/pembelian/add_item";
export const urlUpdateBarang = "/wmsAsset/pembelian/update_item";
export const urlDeleteBarang = "/wmsAsset/pembelian/delete_item";

export const urlGetGudang = "/wmsMasterAsset/gudang/gudang_central";

export const STATUS_OPEN_DRAFT_PEMBELIAN = 0;

// TUTUP belum masuk ke inventory
export const STATUS_PROSES_PEMBELIAN = 1;

// ACCEPT masuk ke inventory
export const STATUS_SELESAI_PEMBELIAN = 2;

export const FORM_RESET_STATE_WMS_PEMBELIAN = {
  id: "",
  idgl: 0,
  date: today(true),

  is_po: false,
  po_id: "",
  po_label: "Cari PO",

  gudang_id: null,
  gudang: "Pilih Gudang Fixed Asset",

  unit_id: null,
  unit: "Pilih Unit",

  user: getUserName(),

  produsen_id: null,
  produsen: "Pilih Produsen",

  supplier_id: null,
  supplier: "Pilih Supplier",

  faktur_no: "",
  faktur_tgl: today(),

  jatuhtempo_tgl: today(),
  kedatangan_tgl: today(),
  tagih_tgl: today(),

  kasbank_id: null,
  kasbank: "Pilih Kas Bank",
  coa_code: "",

  isOpenDraft: false,
  isProcess: false,

  status: STATUS_OPEN_DRAFT_PEMBELIAN,

  biayalain: 0,
  biayalain2: 0,

  ongkos: 0,
  ongkos2: 0,

  potongan: 0,
  potongan2: 0,

  tax: 0,
  tax2: 0,

  sisa: 0,
  is_changesellprice: true,
  bayar: 0,

  type: "create",

  jumlah: 0,
  pembayaran: 0,

  sub_disc: 0,
  sub_total: 0,
  sub_total2: 0,

  total: 0,
  total_jumlah: 0,

  remarkACCP: "",
};

export const getPembelianById = async (id) => {
  try {
    const api = await instance4.get(`${urlGetPembelianById}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: !isNull(res.data)
          ? res.data.totalpembelian
          : {
              totalpembelian: 0,
            },
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getPembelianItemByPembelianId = async (id) => {
  try {
    const api = await instance4.get(
      `${urlGetPembelianItemByPembelianId}/${id}`
    );
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deletePembelianListById = async (id, pembelian_id) => {
  try {
    const api = await instance4.post(urlDeleteBarang, {
      id,
      pembelian_id,
    });
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res,
        message: "Berhasil menghapus pembelian list",
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    align: "left",
  },
  {
    id: "nama_barang",
    disablePadding: false,
    label: "NAMA BARANG",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "satuan",
    disablePadding: false,
    label: "SATUAN BELI",
    align: "left",
    minWidth: "150px",
  },

  {
    id: "qty",
    disablePadding: false,
    label: "QTY",
    align: "left",
  },
  {
    id: "harga_satuan",
    disablePadding: false,
    label: "HARGA",
    align: "left",
  },
  {
    id: "sub_jumlah",
    disablePadding: false,
    label: "SUB JUMLAH",
    align: "left",
    minWidth: "200px",
    sort: false,
  },
  {
    id: "disc",
    disablePadding: false,
    label: "DISC (%)",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nilai_disc",
    disablePadding: false,
    label: "NILAI DISC",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "jumlah",
    disablePadding: false,
    label: "JUMLAH",
    align: "left",
  },
];

export const RenderListPembelian = ({
  classes,
  listPembelian,
  formBarang,
  setFormBarang,
  showModalBarang,
  setShowModalBarang,
  getListPembelian,
  setNewDataPembelianList,
}) => {
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const {
    page,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: listPembelian,
    orderByDefault: "nama_barang",
    orderByRow: ["nama_barang"],
  });
  const { formData } = useContext(FormContext);

  async function deleteList() {
    const res = await deletePembelianListById(formBarang.id, formData.id);
    if (res.state) {
      defaultToastSuccess(res?.message);
      await getListPembelian(formData.id);
      setShowModalDeleteConfirm(false);
    } else {
      defaultToastError(res?.message);
    }
  }

  const handleClickDelete = (row) => {
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
    setFormBarang({
      ...formBarang,
      id: row?.id,
    });
  };

  const handleClickUpdate = (row) => {
    setFormBarang({
      name: row?.nama_barang,
      id: row?.id,
      pembelian_id: row?.pembelian_id,
      barang_id: row?.barang_id,
      satuan_id: row?.satuan_id,
      namasatuan: row?.namasatuan,
      satuanjual_id: row?.satuanjual_id,
      harga2: formatNumber(row?.harga_satuan),
      harga: row?.harga_satuan,
      qty: row?.qty,
      disc: row?.disc,
      nilai_disc: formatNumber(row?.nilai_disc),
      qjb: row?.qjb,
      hargaqjbhpp: convertToValidPrice(row.harga_satuan / row.qjb),
      nobatch: row?.nobatch,
      exired_date: isNull(row.exired_date)
        ? ""
        : defaultDateInputDisplay(row?.exired_date),
      remark: row?.remark,

      po_satuan_id: row?.po_satuan_id,
      po_qty: row?.po_qty,
      po_harga_satuan: formatNumber(row?.po_harga_satuan),
      po_disc: formatNumber(row?.po_disc),
      po_nilai_disc: formatNumber(row?.po_nilai_disc),
    });
    setShowModalBarang(!showModalBarang);
  };

  const handleClickTambah = () => {
    setShowModalBarang(!showModalBarang);
    setFormBarang({
      id: "",
      nama_barang: "",
      pembelian_id: formData.id,
      satuan_id: "",
      harga: 0,
      harga2: formatNumber(0),
      qty: 1,
      disc: 0,
      nilai_disc: 0,
      qjb: 0,
      hargaqjbhpp: convertToValidPrice(0),
      nobatch: "",
      sub_total: formatNumber(0),
      exired_date: "",
      is_proses: true,
      is_po_proses: false,
      remark: "-",
    });
  };

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}
      {showModalBarang && (
        <ModalBarang
          setShowModal={() => setShowModalBarang(false)}
          formBarang={formBarang}
          setFormBarang={setFormBarang}
          setNewDataPembelianList={setNewDataPembelianList}
        />
      )}

      <div
        style={{
          display: "flex",
          gap: "0.5rem",
        }}
      >
        {formData.id !== "" && (
          <>
            <p className="fw-600 mr-1">Status : </p>
            <RenderStatusPembelianBadge status={formData.status} />
          </>
        )}
      </div>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className="mb-1"
      >
        <p className="fw-600 mb-1 mt-1">Data Transaksi Pembelian</p>
        <div
          style={{
            display: "flex",
            gap: "10px",
          }}
        >
          {/* <MasterButton
            onClick={isNull(formData.idpo) ? null : handleClickHistory}
            disabled={false}
            className={"mt-1"}
            type={"button"}
            color={isNull(formData.idpo) ? "secondary" : "lightgreen"}
            name="History Request"
            size="md"
          /> */}
          <MasterButton
            onClick={
              formData.is_po
                ? null
                : isNull(formData.id)
                ? null
                : formData.status === STATUS_PROSES_PEMBELIAN ||
                  formData.status === STATUS_SELESAI_PEMBELIAN
                ? null
                : handleClickTambah
            }
            disabled={false}
            className={"mt-1"}
            type={"button"}
            color={
              formData.is_po
                ? "secondary"
                : isNull(formData.id)
                ? "secondary"
                : formData.status === STATUS_PROSES_PEMBELIAN ||
                  formData.status === STATUS_SELESAI_PEMBELIAN
                ? "secondary"
                : "green"
            }
            name="Tambah Barang"
            size="md"
          />
        </div>
      </Grid>
      <TableContainer className="custom-scrollbar">
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={"medium"}
          aria-label="enhanced table"
        >
          <TableHeader
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={length}
            headCells={headCells}
          />
          <TableBody>
            {stableSort(data, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      padding="none"
                      align="center"
                    >
                      {index + 1}
                    </TableCell>

                    <TableCell
                      component="th"
                      scope="row"
                      padding="none"
                      align="center"
                    >
                      {formData.status === STATUS_OPEN_DRAFT_PEMBELIAN && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "7px",
                          }}
                        >
                          <IconButtonDatatable
                            onClick={() => handleClickUpdate(row)}
                          >
                            <PencilIcon />
                          </IconButtonDatatable>

                          {!formData.is_po && (
                            <IconButtonDatatable
                              onClick={() => handleClickDelete(row)}
                            >
                              <TrashIcon />
                            </IconButtonDatatable>
                          )}
                        </div>
                      )}
                    </TableCell>

                    <RenderTableCell row={row} />
                  </TableRow>
                );
              })}
            {listPembelian.length === 0 && (
              <TableRow>
                <TableCell align="center" colSpan={headCells.length}>
                  Tidak ada data
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <DatatablesFooter
        page={page}
        length={length}
        rowsPerPage={rowsPerPage}
        selectRows={[10, 20, 50, 100]}
        onPageChange={(page) => setPage(page - 1)}
        onSelectChange={(e) => setRowsPerPage(e.target.value)}
      />
    </>
  );
};
export const RenderTableCell = ({ row }) => {
  const subJumlah = parseInt(row?.harga_satuan) * parseInt(row?.qty);
  const nilaiDisc = (parseFloat(row?.disc) / 100) * subJumlah;
  const jumlah = subJumlah - nilaiDisc;

  return (
    <>
      <TableCell align="left">{row?.id}</TableCell>
      <TableCell align="left">{row?.nama_barang}</TableCell>
      <TableCell align="left">{row?.namasatuan}</TableCell>
      <TableCell align="left">{row?.qty}</TableCell>
      <TableCell align="left">{formatNumber(row?.harga_satuan)}</TableCell>
      <TableCell align="left">{formatNumber(subJumlah)}</TableCell>
      <TableCell align="left">{row?.disc}</TableCell>
      <TableCell align="left">{formatNumber(nilaiDisc)}</TableCell>
      <TableCell align="left">{formatNumber(jumlah)}</TableCell>
    </>
  );
};

export const validationInputPembelian = (formData) => {
  const errors = {};

  if (isNull(formData.gudang_id)) {
    errors["gudang_id"] = requiredMsg("Gudang");
  }

  if (isNull(formData.supplier_id)) {
    errors["supplier_id"] = requiredMsg("Supplier");
  }

  if (isNull(formData.kasbank_id)) {
    errors["kasbank_id"] = requiredMsg("Kas Bank");
  }

  return errors;
};
